module.exports = __webpack_public_path__ + "img/vpn-4.713ac8a2.webp";